import { PortfolioHistoryData } from "models/Portfolio/types";
import { IndexData } from 'models/types';
import moment from 'moment';

interface TimeseriesXTickProps {
    x: number;
    y: number;
    payload: {
        value: string | number;
    };
    data: PortfolioHistoryData[] | IndexData[];
}

export default function TimeseriesXTick({ x, y, payload, data }: TimeseriesXTickProps) {
    const value = payload.value;
    const index = data.findIndex(d => {
        if (!d.date) return false;
        if (d.date instanceof moment) {
            return d.date.format('YYYY-MM-DD') === value;
        }
        return false;
    });
    if (index === -1) return null;

    const dataPoint = data[index];
    const formattedDate = dataPoint.date instanceof moment 
        ? dataPoint.date.format('MMM, YYYY')
        : value;

    return (
        <text x={x} y={y + 5} fill="#666" fontSize="12px" textAnchor="middle">
            {formattedDate}
        </text>
    );
}
